var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { BLACK_900, InfoTag, Typography, useBreakpoint, isValidObject, getTestId } from '@airtel/air-design-system';
import { View } from 'react-native';
import { getUpsellTitleStyles } from './UpsellTitleStyles';
import { PriceDetailWidget } from '../../../price-detail-widget';
export var UpsellTitle = props => {
  var title = props.title,
    _props$isTitleCenter = props.isTitleCenter,
    isTitleCenter = _props$isTitleCenter === void 0 ? false : _props$isTitleCenter,
    titleWithDetails = props.titleWithDetails,
    titleWithDetailsProps = props.titleWithDetailsProps,
    infoTagModel = props.infoTagModel,
    priceDetails = props.priceDetails,
    titleType = props.titleType,
    _props$headerAccessib = props.headerAccessibilityProps,
    headerAccessibilityProps = _props$headerAccessib === void 0 ? {} : _props$headerAccessib,
    _props$titleAccessibi = props.titleAccessibilityProps,
    titleAccessibilityProps = _props$titleAccessibi === void 0 ? {} : _props$titleAccessibi,
    _props$infoTagModelAc = props.infoTagModelAccessibilityProps,
    infoTagModelAccessibilityProps = _props$infoTagModelAc === void 0 ? {} : _props$infoTagModelAc,
    style = props.style,
    testID = props.testID,
    restProps = __rest(props, ["title", "isTitleCenter", "titleWithDetails", "titleWithDetailsProps", "infoTagModel", "priceDetails", "titleType", "headerAccessibilityProps", "titleAccessibilityProps", "infoTagModelAccessibilityProps", "style", "testID"]);
  var upsellTitleStyles = getUpsellTitleStyles();
  var _useBreakpoint = useBreakpoint({
      returnAsObject: true
    }),
    isSmallScreen = _useBreakpoint.isSmallScreen;
  var defaultTitleType = isSmallScreen ? 'body-single-line-sm-bold' : 'body-single-line-md-bold';
  var defaultTitleWithDetailsType = isSmallScreen ? 'body-single-line-md' : 'body-single-line-lg';
  return _jsxs(View, Object.assign({
    style: [upsellTitleStyles.container, style]
  }, headerAccessibilityProps, restProps, {
    children: [!!title && _jsx(Typography, Object.assign({}, getTestId(testID, 'title'), {
      text: title,
      type: titleType ? titleType : defaultTitleType,
      textAlignment: "" + (isTitleCenter ? 'center' : 'left'),
      numberOfLines: 1,
      color: BLACK_900
    }, titleAccessibilityProps)), !!(infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagText) && _jsx(InfoTag, Object.assign({
      text: infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagText,
      subType: infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagType,
      size: isSmallScreen ? 'sm' : 'md'
    }, getTestId(testID, 'infoTag'), infoTagModelAccessibilityProps), "infoTag-" + (infoTagModel === null || infoTagModel === void 0 ? void 0 : infoTagModel.infoTagText)), (!!titleWithDetails || isValidObject(titleWithDetailsProps)) && _jsx(Typography, Object.assign({
      text: titleWithDetails,
      type: defaultTitleWithDetailsType,
      style: upsellTitleStyles.titleWithDetailText,
      numberOfLines: 1,
      color: BLACK_900
    }, getTestId(testID, 'titleWithDetails'), titleAccessibilityProps, titleWithDetailsProps)), isValidObject(priceDetails) && _jsx(PriceDetailWidget, Object.assign({}, props === null || props === void 0 ? void 0 : props.priceDetails, {
      style: upsellTitleStyles.priceDetailsSpacing
    }, getTestId(testID, 'priceDetails')))]
  }));
};